export const colourStyles = {
  menuPortal: (base: any) => ({ ...base, zIndex: 9999 }),
  menu: (base: any) => ({ ...base, width: 'auto'}),
  control: (styles: any) => ({
    ...styles,
    backgroundColor: "white",
    border: 'none',
    color: '#322A29',
    boxShadow: "none",
    ":hover": {
      borderColor: "rgba(145, 158, 171, 0.24)",
    },
  }),
  valueContainer: (styles: any) => ({
    ...styles,
    padding: '6px !important',
  }),
  singleValue: (styles: any, { isDisabled }: any) => ({
    ...styles,
    fontSize: 'var(--text-size-body-1)',
    color: isDisabled ? '#999594 !important' : '#322A29 !important',
  }),
  dropdownIndicator: (styles: any, { isDisabled }: any) => ({
    ...styles,
    padding: '0 !important',
    // left: -16,
    "svg": {
      fill: isDisabled ? '#999594 !important' : '#322A29 !important'
    }
  }),
  option: (styles: any, { data, isDisabled, isFocused, isSelected }: any) => {
    return {
      ...styles,
      display: "flex",
      alignItems: "center",
      height: "100%",
      backgroundColor: isDisabled
        ? undefined
        : isSelected
        ? data.color
        : isFocused
        ? "var(--fow-gray-light-color)"
        : undefined,

      color: isDisabled ? "#ccc" : isSelected,
      cursor: isDisabled ? "not-allowed" : "default",

      ":active": {
        ...styles[":active"],
        backgroundColor: !isDisabled
          ? isSelected
            ? data.color
            : "var(--fow-gray-light-color)"
          : undefined,
      },
    };
  },
};
